import request from '@/utils/http.js'

// 获取我的套餐
export const customerServiceInfo = () => {
  return request({
    url: `/salary-service/customer/service_info`,
    method: 'get',
  })
}

// 获取我的订单
export const customerOrder = (params) => {
  return request({
    url: `/salary-service/customer/order`,
    method: 'get',
    params
  })
}

// 获取我的订单
export const rechargeOrder = (data) => {
  return request({
    url: `/salary-service/customer/recharge_order/pager`,
    method: 'post',
    data
  })
}
// 保存显示列
export const saveColumns = (data) => {
  return request({
    url: `/salary-service/customer/save/columns`,
    method: 'post',
    data
  })
}



// 账户余额信息
export const customerBalance = () => {
  return request({
    url: `/salary-service/customer/balance`,
    method: 'get',
  })
}

// 充值中心信息
export const customerRechargePriceAll = () => {
  return request({
    url: `/salary-service/customer/recharge_price/all`,
    method: 'get',
  })
}
// 获取客户发票信息
export const customerinvoiceInfo = () => {
  return request({
    url: `/salary-service/customer/invoice_info`,
    method: 'get',
  })
}

// 获取客户未开发票订单信息
export const ordernoInvoice = (params) => {
  return request({
    url: `/salary-service/customer/order/no_invoice`,
    method: 'get',
    params
  })
}

// 获取客户发票地址信息
export const customerinvoiceAddress = () => {
  return request({
    url: `/salary-service/customer/invoice_address`,
    method: 'get',
  })
}

// 新增客户发票地址信息
export const invoiceAddressCreate = (data) => {
  return request({
    url: `/salary-service/customer/invoice_address/create`,
    method: 'post',
    data
  })
}

// 修改客户发票地址信息
export const invoiceAddressUpdate = (data) => {
  return request({
    url: `/salary-service/customer/invoice_address/update`,
    method: 'put',
    data
  })
}

// 删除客户发票地址信息
export const invoiceAddressDelete = (id) => {
  return request({
    url: `/salary-service/customer/invoice_address/${id}/delete`,
    method: 'delete',
  })
}

// 获取帮助中心分页
export const helpCenterPage = (params) => {
  return request({
    url: `/cms-service/open/SALARY/helpListPage`,
    method: 'get',
    params
  })
}

//根据标识获取分类id
export const openList = (params) => {
  return request({
    url: `/cms-service/open/find/article/by/mask`,
    method: 'get',
    params
  })
}

//根据id获取帮助中心详情
export const helpDetailById = (params) => {
  return request({
    url: `/cms-service/open/helpDetailById`,
    method: 'get',
    params
  })
}

//发票订单查询
export const invoiceOrderPager = (params) => {
  return request({
    url: `/salary-service/customer/invoice_order/pager`,
    method: 'get',
    params
  })
}

//发送记录分页查询
export const sendRecordPager = (data) => {
  return request({
    url: `/salary-service/customer/send_Record/pager`,
    method: 'post',
    data
  })
}

//导出发送记录
export const sendRecordExport = (params) => {
  return request({
    url: `/salary-service/customer/sendRecord/export`,
    method: 'get',
    params,
    responseType: "blob"
  })
}

// 获取当前用户设置
export const setServiceInfo = () => {
  return request({
    url: `/salary-service/common/settings`,
    method: 'get',
  })
}

// 保存修改用户设置通知
export const setSaveSettings = (data) => {
  return request({
    url: `/salary-service/common/saveSettings`,
    method: 'post',
    data
  })
}

// 修改手机号
export const changephone = (data) => {
  return request({
    url: `/authority-center/common/update/mobile?mobile=${data.mobile}&code=${data.code}&id=${data.id}`,
    method: 'post',
    data
  })
}

//选中撤回
export const checkback = (data) => {
  return request({
    url: `/salary-service/customer/send_Record/recall`,
    method: 'post',
    data
  })
}

//部分导出
export const checkExport = (data) => {
  return request({
    url: `/salary-service/customer/send/record/export`,
    method: 'post',
    data,
    responseType: "blob"
  })
}


//获取所有工资条服务套餐信息
export const packagesalary = (params) => {
  return request({
    url: `/salary-service/customer/package/salary`,
    method: 'get',
    params
  })
}


// 根据购买年限获取优惠活动
export const getpreferential = (data) => {
  return request({
    url: `/salary-service/customer/package/preferential`,
    method: 'get',
    data
  })
}



// 工资条服务套餐优惠活动 
export const getPreferentialList = () => {
  return request({
    url: `/salary-service/customer/salary/preferential`,
    method: 'get',
  })
}


// 套餐订单立即支付（生成订单）
export const createorder = (data) => {
  return request({
    url: `/salary-service/customer/order/package/create`,
    method: 'post',
    data
  })
}


// 工资条短信套餐列表 
export const getSmsList = (params) => {
  return request({
    url: `salary-service/package/sms`,
    method: 'get',
    params
  })
}


// 短信套餐订单立即支付
export const getSmsBuy = (data) => {
  return request({
    url: `salary-service/customer/order/sms/create`,
    method: 'post',
    data
  })
}

// 套餐升级
export const upgradepackage = (data) => {
  return request({
    url: `salary-service/customer/order/package/upgrade`,
    method: 'post',
    data
  })
}

// 短信签名申请
export const addsmssign = (data) => {
  return request({
    url: `sms-center/common/sign/add`,
    method: 'post',
    data,
  })
}

// 短信签名列表
export const getsmssign = (params) => {
  return request({
    url: `sms-center/common/sign/page`,
    method: 'get',
    params,
  })
}

// 删除短信签名
export const delsmssign = (params) => {
  return request({
    url: `sms-center/common/sign/delete`,
    method: 'post',
    params
  })
}
// 短信发送列表
export const smssendlist = (params) => {
  return request({
    url: `sms-center/common/group`,
    method: 'get',
    params
  })
}
// 短信发送列表
export const smssendlog = (params) => {
  return request({
    url: `sms-center/common/log`,
    method: 'get',
    params
  })
}

// 获取全部短信签名
export const getsmssigntotle = (params) => {
  return request({
    url: `sms-center/common/sign`,
    method: 'get',
    params
  })
}

// 修改短信签名
export const updatesmssign = (data) => {
  return request({
    url: `sms-center/common/sign/modify`,
    method: 'post',
    data
  })
}

// 邮箱模板还原
export const emailreset = () => {
  return request({
    url: `salary-service/customer/email/return`,
    method: 'put',
  })
}

// 企业微信授权
export const qywxauthor = () => {
  return request({
    url: `salary-service/open/qywx/auth`,
    method: 'get',
  })
}



// 新建第二步点击下一步自定义模板处理
export const next = (data) => {
  return request({
    url: `salary-service/customer/next`,
    method: 'post',
    data
  })
}

// 检查重复数据
export const checkRepeat = (data) => {
  return request({
    url: `salary-service/customer/checkRepeat`,
    method: 'post',
    data
  })
}

// 检查违规信息
export const checkIllegal = (data) => {
  return request({
    url: `salary-service/customer/checkIllegal`,
    method: 'post',
    data
  })
}

// 检查套餐条数
export const checkPackage = (data) => {
  return request({
    url: `salary-service/customer/checkPackage`,
    method: 'post',
    data
  })
}


// 导出短信发送失败的记录
export const exportfailSms = (params) => {
  return request({
    url: `sms-center/common/export/sms`,
    method: 'get',
    params,
    responseType: "blob"
  })
}


// 下载发票图片/salary-service/open/invoice/{id}/download
export const downloadimg = (id) => {
  return request({
    url: `salary-service/open/invoice/${id}/download`,
    method: 'get',
  })
}


// 调查问卷
export const customerQuestionnaire = (data) => {
  return request({
    url: `salary-service/customer/questionnaire`,
    method: 'post',
    data
  })
}
//是否回答了调查问卷
export const customerAnswercheck = (id) => {
  return request({
    url: `salary-service/customer/${id}/answer`,
    method: 'get',
  })
}

// 子管理员分页
export const getUserTable = (params) => {
  return request({
    url: `authority-center/tenant/user/page`,
    method: 'get',
    params
  })
}


//发送记录标题
export const getsendRecordinfo = (params) => {
  return request({
    url: `salary-service/customer/send_Record/info`,
    method: 'get',
    params
  })
}


//  获取所有工资条短信套餐信息
export const getSmspackage = (params) => {
  return request({
    url: `salary-service/customer/package/sms`,
    method: 'get',
    params
  })
}
// 删除发送记录
export const recordDelete = (data) => {
  return request({
    url: `salary-service/customer/send/record/delete`,
    method: 'post',
    data
  })
}

// /根据APP和父级CODE获取字典信息
export const getTypeList = (params) => {
  return request({
    url: `dict-service/open/item/salary/工资条薪资类型`,
    method: 'get',
    params
  })
}

// 更具orgid获取所有公司名称 
export const getcompanybyorgId = (orgId) => {
  return request({
    url: `authority-center/internal/get/all/company/name/by/${orgId}`,
    method: 'get',
  })
}
// 更具id获取所有公司名称 
export const getcompanybyId = (id) => {
  return request({
    url: `authority-center/internal/find/all/company/name/by/${id}`,
    method: 'get',
  })
}

// 发送记录统计
export const sendRecord = (params) => {
  return request({
    url: `salary-service/customer/count/send/record`,
    method: 'post',
    params
  })
}

// 取消发送
export const cancelSending = (params) => {
  return request({
    url: `salary-service/customer/cancel/sending`,
    method: 'post',
    params
  })
}

export const cancelSendingAll = (data) => {
  return request({
    url: `salary-service/customer/cancel/sending/all`,
    method: 'post',
    data
  })
}


